import {
  createOption,
  CreateOptionMutation,
  CreateOptionMutationVariables,
  createRecordOption,
  CreateRecordOptionMutation,
  CreateRecordOptionMutationVariables,
  deleteRecordOption,
  DeleteRecordOptionMutation,
  DeleteRecordOptionMutationVariables,
  graphqlCall,
  updateOption,
  UpdateOptionMutation,
  UpdateOptionMutationVariables,
} from '@akin-home/amplify';

export const createOptionMutation = (input: CreateOptionMutationVariables) =>
  graphqlCall<CreateOptionMutation>(createOption, input);

export const updateOptionMutation = (input: UpdateOptionMutationVariables) =>
  graphqlCall<UpdateOptionMutation>(updateOption, input);

export const createRecordOptionMutation = (
  input: CreateRecordOptionMutationVariables
) => graphqlCall<CreateRecordOptionMutation>(createRecordOption, input);

export const deleteRecordOptionMutation = (
  input: DeleteRecordOptionMutationVariables
) => graphqlCall<DeleteRecordOptionMutation>(deleteRecordOption, input);

